import React, { useState } from "react";

import g4 from "../Assets/products/indoor-p18.png";
import g5 from "../Assets/products/indoor-p15.jpg";
import g8 from "../Assets/asset03.jpg";
import g10 from "../Assets/asset05.jpg";
import g11 from "../Assets/asset06.jpg";
import g13 from "../Assets/indoor-led.jpg";
import g14 from "../Assets/indoor-led2.jpg";
import g17 from "../Assets/outdoor-led.jpg";
import g19 from "../Assets/outdoorads.jpeg";
import g20 from "../Assets/p6.jpeg";
import g30 from "../Assets/Product/LEDP8.jpeg";
import g31 from "../Assets/Product/LEDP6.jpeg";
import g32 from "../Assets/Product/LEDP5.jpeg";
import g33 from "../Assets/Product/LED P3.jpeg";
import g34 from "../Assets/Product/LED P4.jpeg";
import g35 from "../Assets/Product/LED P2.jpeg";
import g36 from "../Assets/Product/LED P1.jpeg";

// Example structure — continue for all 62
const galleryData = [
  { img: g4, category: "LED Complete Project" },
  {img: g5, category: "Audio Visuals"},
  {img: g8, category: "Audio Visuals"},
  {img:g10, category: "LED Complete Project"},
  {img:g11, category: "Audio Visuals"},{
  img:g13, category: "Audio Visuals"
  },
  {img:g14, category:"Audio Visuals"},
  {img:g17, cateogry: "Audio Visuals"},
  {img: g19, cateogry:"Audio Visuals"},
  {img:g20, category: "LED Complete Project"},
  {img:g30, category: "LED Complete Project"},
  {img:g31, category: "LED Complete Project"},
  {img:g32, category: "LED Complete Project"},
  {img:g33, category: "LED Complete Project"},
  {img:g34, category: "LED Complete Project"},
  {img:g35, category: "LED Complete Project"},
  {img:g36, category: "LED Complete Project"}
  
];

const Gallery = () => {
  const [activeFilter, setActiveFilter] = useState("All");

  const categories = [
    "All",
    "LED Complete Project",
  ];

  const filteredImages =
    activeFilter === "All"
      ? galleryData
      : galleryData.filter((item) => item.category === activeFilter);

  const getCount = (category) => {
    if (category === "All") return galleryData.length;
    return galleryData.filter((item) => item.category === category).length;
  };

  return (
    <div className="w-full bg-white min-h-screen py-20">
      <div className="max-w-7xl mx-auto px-6">

        {/* Heading */}
        <h1 className="text-4xl md:text-5xl font-bold text-center mb-12">
          Gallery
        </h1>

        {/* Filter Buttons */}
        <div className="flex flex-wrap justify-center gap-4 mb-14">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveFilter(category)}
              className={`px-6 py-2 rounded-full text-sm font-medium transition ${
                activeFilter === category
                  ? "bg-black text-white"
                  : "bg-green-500 text-white hover:bg-green-600"
              }`}
            >
              {category} ({getCount(category)})
            </button>
          ))}
        </div>

        {/* Image Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredImages.map((item, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-xl shadow-md"
            >
              <img
                src={item.img}
                alt="gallery"
                className="w-full h-72 object-cover transition duration-500 group-hover:scale-110"
              />

              {/* Hover Overlay */}
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 transition duration-500"></div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default Gallery;